import { createStreamEpic } from '../../../signalr/createStreamEpic'
import { subscribeToUserDashboardDefinition } from './definition'

export default createStreamEpic(
  'userDashboard.subscribe',
  subscribeToUserDashboardDefinition
)
